export default "__VITE_ASSET__BcTuNEMc__"